import { render, staticRenderFns } from "./InsertButton.vue?vue&type=template&id=0c5d03ed&scoped=true"
import script from "./InsertButton.vue?vue&type=script&lang=js"
export * from "./InsertButton.vue?vue&type=script&lang=js"
import style0 from "./InsertButton.vue?vue&type=style&index=0&id=0c5d03ed&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5d03ed",
  null
  
)

export default component.exports